import { Styled } from "./styles";
import { useAppContext } from "src/hooks/useAppContext";
import { getSecureUrl } from "src/domains/media/mediaPreview";

interface OrgGlyphBaseProps {
  height?: number;
  width?: number;
  borderRadius?: number;
}
interface WithGlyphProps extends OrgGlyphBaseProps {
  glyph: string;
}
interface WithOrgNameProps extends OrgGlyphBaseProps {
  organizationName: string;

  fontSize?: string;
  fontWeight?: number;
}
type OrgGlyphProps = WithGlyphProps | WithOrgNameProps;

export const OrgGlyph = (props: OrgGlyphProps) => {
  const { height, width, borderRadius } = props;
  const context = useAppContext();

  const renderLogo = () => {
    if ("glyph" in props && props.glyph) {
      const secureGlyph = getSecureUrl(props.glyph, context.secureMediaPolicy);
      return <img src={secureGlyph} />;
    } else if ("organizationName" in props && props.organizationName) {
      const { fontSize, fontWeight } = props;
      return (
        <span
          style={{
            fontSize: fontSize ?? "20px",
            fontWeight: fontWeight ?? 900,
          }}
        >
          {props.organizationName[0] ?? ""}
        </span>
      );
    }
    return <></>;
  };

  const removeGlyphBackgroundColor: boolean = "glyph" in props && !!props.glyph;

  return (
    <Styled
      borderRadius={borderRadius}
      width={width}
      height={height}
      removeBackgroundColor={removeGlyphBackgroundColor}
    >
      <div className="org-glyph">{renderLogo()}</div>
    </Styled>
  );
};
